export function pad(num: number) {
  const s = '0' + num;
  return s.slice(-2);
}

export function formatTime(date: Date) {
  return pad(date.getHours()) + ':' + pad(date.getMinutes());
}

export function formattingTime(time: string) {
  const splitTime = time.split(':');
  const hour = parseInt(splitTime[0]) % 24,
    minute = parseInt(splitTime[1]);
  return {
    hour,
    minute,
    isPm: hour >= 12 ? 12 : 0,
  };
}
